export default __webpack_public_path__ + "fonts/c0441cde938d1ae40121a55e074e7f911b98ded41138769cdd0ff70815a27717.ttf";